<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-100">
        <div class="p-6 max-w-sm w-full bg-white shadow-lg rounded-lg">
            <h2 class="text-2xl font-bold mb-6 text-center">Sign up</h2>

            <div class="flex flex-col gap-4">
                <label class="ui-input ui-input-bordered flex items-center gap-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        class="h-4 w-4 opacity-70"
                    >
                        <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
                        <path d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
                    </svg>
                    <input
                        v-model="email"
                        type="text"
                        class="grow"
                        placeholder="Email"
                    />
                </label>

                <label class="ui-input ui-input-bordered flex items-center gap-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        class="h-4 w-4 opacity-70"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M14 6a4 4 0 0 1-4.899 3.899l-1.955 1.955a.5.5 0 0 1-.353.146H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2.293a.5.5 0 0 1 .146-.353l3.955-3.955A4 4 0 1 1 14 6Zm-4-2a.75.75 0 0 0 0 1.5.5.5 0 0 1 .5.5.75.75 0 0 0 1.5 0 2 2 0 0 0-2-2Z"
                            clip-rule="evenodd"
                        />
                    </svg>
                    <input
                        v-model="password"
                        type="password"
                        class="grow"
                        value=""
                        placeholder="Password"
                    />
                </label>
                <label class="ui-input ui-input-bordered flex items-center gap-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        class="h-4 w-4 opacity-70"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M14 6a4 4 0 0 1-4.899 3.899l-1.955 1.955a.5.5 0 0 1-.353.146H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2.293a.5.5 0 0 1 .146-.353l3.955-3.955A4 4 0 1 1 14 6Zm-4-2a.75.75 0 0 0 0 1.5.5.5 0 0 1 .5.5.75.75 0 0 0 1.5 0 2 2 0 0 0-2-2Z"
                            clip-rule="evenodd"
                        />
                    </svg>
                    <input
                        v-model="password2"
                        type="password"
                        class="grow"
                        value=""
                        placeholder="Confirm Password"
                    />
                </label>

                <div
                    v-if="invalidFeedback"
                    role="alert"
                    class="ui-alert ui-alert-error"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 shrink-0 stroke-current"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                    <span>{{ invalidFeedback }}</span>
                </div>

                <!-- Login Button -->
                <button
                    class="ui-btn bg-primary mt-4"
                    @click="signUp"
                >
                    Sign up
                </button>

                <!-- Sign Up link -->
                <a class="ui-link ui-link-neutral mx-auto">
                    <router-link to="/login">Already have an account? Login</router-link>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { auth } from 'system/firebase.js';

export default {
    name: 'Signup',
    data() {
        return {
            email: '',
            password: '',
            password2: '',
            invalidFeedback: '',
        };
    },
    methods: {
        signUp() {
            if (!this.email.includes('@')) {
                this.invalidFeedback = 'Oops, the provided email is not valid';
                return;
            }

            if (this.password !== this.password2) {
                this.invalidFeedback = 'Oops, passwords do not match';
                return;
            }

            createUserWithEmailAndPassword(auth, this.email, this.password)
                .then(async (response) => {
                    console.log('create response', response);
                    await sendEmailVerification(auth.currentUser);
                    this.$router.push({ name: 'today' });
                })
                .catch((error) => {
                    if (error.code === 'auth/email-already-in-use') {
                        this.invalidFeedback = 'Oops, the provided email is already in use';
                    } else if (error.code === 'auth/invalid-email') {
                        this.invalidFeedback = 'Oops, the provided email is not valid';
                    } else if (error.code === 'auth/weak-password') {
                        this.invalidFeedback = 'Oops, the provided password is weak';
                    } else {
                        this.invalidFeedback = 'Oooops, error creating user';
                        console.log(error);
                    }
                });
        },
    },
};
</script>
